import React, { useMemo, useState, useEffect } from 'react'
import { Row, Col, Form, Button as BootstrapButton } from 'react-bootstrap'
import {Link, useNavigate} from 'react-router-dom'
import Card from '../../../components/Card'
import { API_COMPANY_LIST, API_COMPANY_CREDITS, API_COMPANY_PROFILE, API_TTS_CREDITS } from '../../../service/url';
import Modal from "react-bootstrap/Modal";
import { getApiCall, postApiCall } from '../../../service/httpCall';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import Loader  from '../../../components/partials/components/loader';
import { Target, Users, MapPin } from 'lucide-react';
import "../../../assets/custom/css/custom.css";
import { ROUTES, USER_CREDITS_ACTION, TTS_CREDITS_ACTION } from '../../../utilities/constant';
import { USER_ROLES , MODULE_ACL} from '../../../utilities/constant';
import { getUser } from "../../../utilities/setting";
import { Dropdown as BootstrapDropdown } from "react-bootstrap";
import RenderAddCreditModal from "../../../components/partials/components/add-credit-model";
import RenderRemoveCreditModal from "../../../components/partials/components/remove-credit-model";
import { toast } from 'react-toastify';
import exportData from '../../../utilities/export';
import { API_COMPANY_DELETE } from '../../../service/url';
import { FaTrash } from "react-icons/fa";

//theme
import 'primereact/resources/themes/lara-light-indigo/theme.css';
//core
import 'primereact/resources/primereact.min.css';
import { FiPlus } from 'react-icons/fi';

const CompanyList = () =>{

   const navigate = useNavigate();
   const [companylist, setCompanylist] = useState([]);
   const [loading, setLoading] = useState(false);
   const [isSuperAdmin, setIsSuperadmin] = useState(false)
   const [isReseller, setIsReseller] = useState(false)
   const [currentUserId, setCurrentUserId] = useState("")
   const [currentUserRole, setCurrentUserRole] = useState("")
   const [addCreditsId, setAddCreditsId] = useState(null);
   const [removeCreditsId, setRemoveCreditsId] = useState(null);
   const [showRemoveCreditModel, setShowRemoveCreditModel] = useState(false);
   const [confirmReduceCredits, setConfirmReduceCredits] = useState(false);
   const [removeCreditsValue, setRemoveCreditsValue] = useState(0);
   const [showAddCreditModel, setShowAddCreditModel] = useState(false);
   const [confirmCredits, setConfirmCredits] = useState(false);
   const [addCreditsValue, setAddCreditsValue] = useState(0);
   const [showGroupsModal, setShowGroupsModal] = useState(false);
   const [showLocationsModal, setShowLocationsModal] = useState(false);
   const [selectedCompanyName, setSelectedCompanyName] = useState(null);
   const [selectedGroups, setSelectedGroups] = useState([]);
   const [selectedLocations, setSelectedLocations] = useState([]);
   const [showDeleteModal, setShowDeleteModal] = useState(false);
   const [deleteId, setDeleteId] = useState(null);

   const [toastProps, setToastProps] = useState(null);
   const [showToast, setShowToast] = useState(false);
   const [searchValue, setSearchValue] = useState("");
   const [loggedInUser, setLoggedInUser] = useState(null);
   const [isOwnCompany, setIsOwnCompany] = useState(false);
   const [showStrategiesModal, setShowStrategiesModal] = useState(false);
   const [userCallStratgies, setUserCallStrategies] = useState(null);
   const [userCallStrategiesUserName, setUserCallStrategiesUserName] = useState(null);
   const [loggedInUserACL, setLoggedInUserACL] = useState({})

   const [showAddTtsCreditModel, setShowAddTtsCreditModel] = useState(false);
   const [confirmTtsCredits, setConfirmTtsCredits] = useState(false);
     const [addTtsCreditsValue, setAddTtsCreditsValue] = useState(0);
     const [showRemoveTtsCreditModel, setShowRemoveTtsCreditModel] = useState(false);
     const [confirmReduceTtsCredits, setConfirmReduceTtsCredits] = useState(false);
     const [removeTtsCreditsValue, setRemoveTtsCreditsValue] = useState(0);

     const [addTtsCreditsId, setAddTtsCreditsId] = useState(null);
     const [removeTtsCreditsId, setRemoveTtsCreditsId] = useState(null);
     const [loggedInUserId, setLoggedInUserId] = useState(null);
     const [buttonDisable, setButtonDisable] = useState(false);
   
   

    useEffect(() => {
        getUser().then((user) => {
          if (user) {
            setLoggedInUser(user);
            setCurrentUserId(user.id)
            setCurrentUserRole(user.role)
            setLoggedInUserId(user.id);
            if (user.role === USER_ROLES.SUPERADMIN) {
               setIsSuperadmin(true);
            }
            if (user.role === USER_ROLES.RESELLER) {
               setIsReseller(true);
            }
            if (user?.acl_settings) {
               setLoggedInUserACL(JSON.parse(user.acl_settings.module_operations));
            }
          }
        });
      }, []);

        // useEffect(() => {
        //   if (toastProps) {
        //     setShowToast(true);
        //   }
        // }, [toastProps]);

  useEffect(() => {
    let isMounted = true;

    const fetchAssignedCompany = async () => {
      if (!loggedInUser) {
        setLoading(false);
        return;
      }

      setLoading(true);

      try {
        if (
          loggedInUser?.assignedCompany &&
          loggedInUser.assignedCompany?.is_own_company
        ) {
          const fetchedAssignedCompanyData = await getApiCall(
            API_COMPANY_PROFILE.replace(
              ":id",
              loggedInUser.assigned_company
            )
          );

          if (!isMounted) return;

          const licence = fetchedAssignedCompanyData?.subUserLicenceId?.available_licence || {};

          const assignedCompanyOfLoggedInUser = [
            {
              key: 1,
              name: loggedInUser.assignedCompany.name,
              phone: loggedInUser.assignedCompany.phone,
              address: loggedInUser.assignedCompany.address,
              pincode: loggedInUser.assignedCompany.pincode,
              credits_available:
                loggedInUser.assignedCompany.credits_available,
              created_at: loggedInUser.assignedCompany.created_at,
              updated_at: loggedInUser.assignedCompany.updated_at,
              company_creator: {
                username: loggedInUser?.createdByUser?.username
              },
              available_licence: licence,
              is_own_company: loggedInUser?.assignedCompany?.is_own_company,
              is_reseller_company: loggedInUser?.assignedCompany?.is_reseller_company,
              company_code: loggedInUser?.assignedCompany?.company_code,
              companyCallStrategies: loggedInUser?.assignedCompany?.companyCallStrategies || [],
              companyGroups: loggedInUser?.assignedCompany?.companyGroups || [],
              companyLocations: loggedInUser?.assignedCompany?.companyLocations || [],
            }
          ];

          setCompanylist(assignedCompanyOfLoggedInUser);
          setIsOwnCompany(true);
        } else {
          const list = await getApiCall(API_COMPANY_LIST, {});
          if (!isMounted) return;
          onCompanyListSuccess(list);
          setIsOwnCompany(false);
        }
      } catch (err) {
        onError(err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchAssignedCompany();

    return () => {
      isMounted = false;
    };
  }, [loggedInUser]);

   async function handleAddCredits(id) {
      setShowAddCreditModel(true);
      setAddCreditsId(id);
   }
  
    async function handleRemoveCredits(id) {
      const company = companylist.find(c => c.id === id);
      setShowRemoveCreditModel(true);
      setRemoveCreditsId(id);
      setRemoveCreditsValue(0);
      // Store available credits for validation
      if (company) {
        setRemoveCreditsValue(0);
      }
    }

    async function handleAddTtsCredits(id) {
      setShowAddTtsCreditModel(true);
      setAddTtsCreditsId(id);
    }

    async function handleRemoveTtsCredits(id) {
      const company = companylist.find(c => c.id === id);
      setShowRemoveTtsCreditModel(true);
      setRemoveTtsCreditsId(id);
      setRemoveTtsCreditsValue(0);
      // Store available TTS credits for validation
      if (company) {
        setRemoveTtsCreditsValue(0);
      }
    }

    const handleExport = async () => {
      await exportData('Company', setToastProps, setShowToast);
    };

    const strategiesTemplate = (rowData) => {
        if (!rowData.companyCallStrategies || rowData.companyCallStrategies.length === 0) {
          return "No Strategies";
        }
    
        return (
          <Button
            onClick={() => {
              const strategyNames = rowData.companyCallStrategies
                .filter(strategy => strategy.strategyMaster && !strategy.is_deleted)
                .map(strategy => strategy.strategyMaster.name);
      
              setUserCallStrategies(strategyNames?.join(", "));
              setShowStrategiesModal(true);
              setUserCallStrategiesUserName(rowData.name);
            }}
            className="p-button-active p-button-sm"
            style={{ padding: "5px 10px", display: "inline-flex", alignItems: "center", gap: "6px" }}
          >
            <Target size={16} />
            <span>View Strategies</span>
          </Button>
        );
      };
  
      const groupsTemplate = (rowData) => {
        if (!rowData.companyGroups || rowData.companyGroups.length === 0) {
          return "No Groups";
        }
      
        return (
          <Button
            onClick={() => {
              const groupNames = rowData.companyGroups
                .filter(g => g.groups && !g.groups.is_deleted)
                .map(g => g.groups.group_name);
      
              setSelectedGroups(groupNames);
              setSelectedCompanyName(rowData.name);
              setShowGroupsModal(true);
            }}
            className="p-button-active p-button-sm"
            style={{ padding: "5px 10px", display: "inline-flex", alignItems: "center", gap: "6px" }}
          >
            <Users size={16} />
            <span>View Groups</span>
          </Button>
        );
      };
  
  const locationsTemplate = (rowData) => {
    if (!rowData.companyLocations || rowData.companyLocations.length === 0) {
      return "No Locations";
    }
  
    return (
      <Button
        onClick={() => {
          const locationNames = rowData.companyLocations
            .filter(l => l.locations && !l.locations.is_deleted)
            .map(l => l.locations.location_name);
  
          setSelectedLocations(locationNames);
          setSelectedCompanyName(rowData.name);
          setShowLocationsModal(true);
        }}
        className="p-button-active p-button-sm"
        style={{ padding: "5px 10px", display: "inline-flex", alignItems: "center", gap: "6px" }}
      >
        <MapPin size={16} />
        <span>View Locations</span>
      </Button>
    );
  };

     useEffect(() => {
       if(confirmCredits){
         if (addCreditsValue == 0) {
          toast.error("Please add some credit value to increase");
         }
         else {
           let apiUrl = API_COMPANY_CREDITS.replace(":id", addCreditsId);
           postApiCall(apiUrl, { 
             id: addCreditsId, 
             updatedCredit: addCreditsValue, 
             action: USER_CREDITS_ACTION.ADD, 
             fromUser: currentUserId
           })
           .then(onUserCreditsUpdatedSuccess)
           .catch(onUserCreditsUpdatedFailed)
         }
       }
     }, [confirmCredits, addCreditsValue]);
   
     useEffect(() => {
       if(confirmReduceCredits){
         if (removeCreditsValue == 0) {
          toast.error("Please add some credit value to reduce");
         }
         else {
           let apiUrl = API_COMPANY_CREDITS.replace(":id", removeCreditsId);
           postApiCall(apiUrl, { id: removeCreditsId, updatedCredit: removeCreditsValue, action: USER_CREDITS_ACTION.DEDUCT, fromUser: currentUserId })
           .then(onUserCreditsUpdatedSuccess)
           .catch(onUserCreditsUpdatedFailed)
         }
       }
     }, [confirmReduceCredits, removeCreditsValue]);

     function openDeleteModal(id) {
           setDeleteId(id);
           setShowDeleteModal(true);
        }
     
        function closeDeleteModal() {
           setDeleteId(null);
           setShowDeleteModal(false);
        }
     
        async function confirmDelete() {
           try {
              setButtonDisable(true);
     
              const url = API_COMPANY_DELETE.replace(":id", deleteId);
              await postApiCall(url, {});
              toast.success("Company deleted successfully");
     
              closeDeleteModal();
              setLoading(true);
              const resp = await getApiCall(API_COMPANY_LIST, {});
              onCompanyListSuccess(resp);
     
           } catch (err) {
              toast.error(JSON.stringify(err) || "Failed to delete company");
              onError(err);
           } finally {
              setLoading(false);
              setButtonDisable(false);
           }
        }

  //  function onUserCreditsUpdatedSuccess(resp) {
  //     setConfirmCredits(false);
  //     setConfirmReduceCredits(false);
  //     setRemoveCreditsValue(0);
  //     setAddCreditsValue(0);
  //     setShowAddCreditModel(false);
  //     setShowRemoveCreditModel(false);
  //     toast.success("Company Credits Updated Successfully");
  //   }
  

    function onUserCreditsUpdatedSuccess(resp) {
      const updatedCompanyId = addCreditsId || removeCreditsId;
      const creditDelta = confirmCredits ? Number(addCreditsValue) : -Number(removeCreditsValue);
      setCompanylist(prevList =>
        prevList.map(company => {
          if (company.id === updatedCompanyId) {
            const updatedCredits = Number(company.credits_available || 0) + creditDelta;
            return {
              ...company,
              credits_available: roundTo2(updatedCredits),
            };
          }
          return company;
        })
      );
      setConfirmCredits(false);
      setConfirmReduceCredits(false);
      setRemoveCreditsValue(0);
      setAddCreditsValue(0);
      setShowAddCreditModel(false);
      setShowRemoveCreditModel(false);
      toast.success("Company Credits Updated Successfully");
    }

    function roundTo2(num) {
      return Math.round((num + Number.EPSILON) * 100) / 100;
    }
  
    function onUserCreditsUpdatedFailed(error) {
      setConfirmCredits(false);
      setConfirmReduceCredits(false);
      setRemoveCreditsValue(0);
      setAddCreditsValue(0);
      setShowAddCreditModel(false);
      setShowRemoveCreditModel(false);
      toast.error(error);
    }

   function onCompanyListSuccess(resp){
      const updatedList = resp.map( (val, idx) => {
         val['key'] = idx+1;
         val['created_at'] = new Date(val['created_at']).toGMTString();
         return val;
      } );
      setCompanylist(updatedList);
   }

   const handleAllocateClick = (id, role) => {
      navigate(`/allocate/${currentUserId}/${id}/company`);
    };

   function RenderActionComponent(id, role){
      const companyEditRoute = ROUTES.COMPANIES.EDIT.replace(":id", id);
      return (
         <div className="flex align-items-center list-user-action">
            {' '}
            <BootstrapDropdown>
               <BootstrapDropdown.Toggle
                          variant="primary"
                          size="sm"
                          id={`dropdown-basic-${id}`}
                          style={{ marginLeft: "5px", width: "150px" }}
                        >
                          View Actions
                        </BootstrapDropdown.Toggle>
                         <BootstrapDropdown.Menu
                                      popperConfig={{
                                        modifiers: [
                                          {
                                            name: "preventOverflow",
                                            options: { boundary: "viewport" },
                                          },
                                          {
                                            name: "flip",
                                            options: { fallbackPlacements: ["top", "bottom"] },
                                          },
                                        ],
                                      }}
                                      style={{ maxHeight: "300px", overflowY: "auto" }}
                                    >
                                      {(isSuperAdmin || loggedInUserACL?.[MODULE_ACL.COMPANY]?.edit) && (
                                       <BootstrapDropdown.Item onClick={() => navigate(`/${companyEditRoute}`)}>
                                         Edit Company
                                       </BootstrapDropdown.Item>
                                      )}
                                       <BootstrapDropdown.Item onClick={() => handleAllocateClick(id, role)}>
                                          Allocate Number
                                       </BootstrapDropdown.Item>
                                        <BootstrapDropdown.Item onClick={() => handleAddCredits(id)}>
                                          Add Voice Credits
                                        </BootstrapDropdown.Item>
                                        <BootstrapDropdown.Item onClick={() => handleRemoveCredits(id)}>
                                          Remove Voice Credits
                                        </BootstrapDropdown.Item>
                                        <BootstrapDropdown.Item onClick={() => handleAddTtsCredits(id)}>
                                          Add TTS Credits
                                        </BootstrapDropdown.Item>
                                        <BootstrapDropdown.Item onClick={() => handleRemoveTtsCredits(id)}>
                                          Remove TTS Credits
                                        </BootstrapDropdown.Item>
                                        <BootstrapDropdown.Item onClick={() => openDeleteModal(id)}>
                                          Delete Company
                                        </BootstrapDropdown.Item>
                                    </BootstrapDropdown.Menu>
                                  </BootstrapDropdown>
         </div>
      );

   }

   function onError(err){
      console.log(err);
   }

   const handleCreateButtonClick = () => {
      navigate(`/${ROUTES.COMPANIES.CREATE}`);
   } 

   useEffect(() => {
    if (confirmTtsCredits) {
      if (addTtsCreditsValue == 0) {
        toast.error("Please add some TTS credit value to increase");
      }
      else {
        let apiUrl = API_TTS_CREDITS.replace(":id", addTtsCreditsId);
        postApiCall(apiUrl, {
          id: addTtsCreditsId,
          updatedCredit: addTtsCreditsValue,
          action: TTS_CREDITS_ACTION.ADDITION,
          fromUser: loggedInUserId
        })
        .then(onUserTtsCreditsUpdatedSuccess)
        .catch(onUserTtsCreditsUpdatedFailed)
      }
    }
  }, [confirmTtsCredits, addTtsCreditsValue]);
   
     useEffect(() => {
       if (confirmReduceTtsCredits) {
         if (removeTtsCreditsValue == 0) {
           toast.error("Please add some TTS credit value to reduce");
         }
         else {
           let apiUrl = API_TTS_CREDITS.replace(":id", removeTtsCreditsId);
           postApiCall(apiUrl, { id: removeTtsCreditsId, updatedCredit: removeTtsCreditsValue, action: TTS_CREDITS_ACTION.DEDUCTION, fromUser: loggedInUserId })
             .then(onUserTtsCreditsUpdatedSuccess)
             .catch(onUserTtsCreditsUpdatedFailed)
         }
       }
     }, [confirmReduceTtsCredits, removeTtsCreditsValue]);
   
     function onUserTtsCreditsUpdatedSuccess(resp) {
  const updatedCompanyId = addTtsCreditsId || removeTtsCreditsId;
  const creditDelta = confirmTtsCredits
    ? Number(addTtsCreditsValue)
    : -Number(removeTtsCreditsValue);

  setCompanylist(prevList =>
    prevList.map(company => {
      if (company.id === updatedCompanyId) {
        const updatedTtsCredits = Number(company.tts_credits || 0) + creditDelta;
        return {
          ...company,
          tts_credits: roundTo2(updatedTtsCredits),
        };
      }
      return company;
    })
  );

  setConfirmTtsCredits(false);
  setConfirmReduceTtsCredits(false);
  setRemoveTtsCreditsValue(0);
  setAddTtsCreditsValue(0);
  setShowAddTtsCreditModel(false);
  setShowRemoveTtsCreditModel(false);
  toast.success("Company TTS Credits Updated Successfully");
}

   
     function onUserTtsCreditsUpdatedFailed(error) {
       setConfirmTtsCredits(false);
       setConfirmReduceTtsCredits(false);
       setRemoveTtsCreditsValue(0);
       setAddTtsCreditsValue(0);
       setShowAddTtsCreditModel(false);
       setShowRemoveTtsCreditModel(false);
       toast.error(error);
     }

   const displayedCompanyList = useMemo(() => {
      const q = searchValue.trim().toLowerCase();
      if (!q) return companylist;
      return companylist.filter((c) => (c?.name || "").toLowerCase().includes(q));
   }, [companylist, searchValue]);

   if (loading) {
      return <Loader />
   }

  return(
     <>
       <div>
         <Row>
            <Col sm="12">
               <Card>
                  <Card.Header className="d-flex justify-content-between">
                     <div className="header-title">
                        <h4 className="card-title">Company List</h4>
                     </div>
                     <div className="d-flex justify-content-flex-end">
                     {companylist.length > 0 && !isOwnCompany &&
                        <Button 
                          label="Export Data"
                          icon="pi pi-file-export"
                          onClick={handleExport} 
                          className="p-button-active p-button-sm" 
                          style={{ marginRight: '10px' }} 
                        >
                        </Button>
                      }
                      {(isSuperAdmin || loggedInUserACL?.[MODULE_ACL.COMPANY]?.add)
                        ? (!isOwnCompany && (
                            <button
                              className="btn btn-primary ml-auto"
                              onClick={handleCreateButtonClick}
                            >
                              <FiPlus className="me-1" />
                              Create Company
                            </button>
                          ))
                        : null}

                     </div>
                  </Card.Header>
                  <Card.Body className="px-0">
                  <div style={{ display: "flex", flexDirection: "row", overflowX: "auto" }}>
                     <Form.Group style={{ marginLeft: "10px", marginTop: "10px", marginBottom: "10px", flexShrink: 0 }}>
                        <Form.Control
                           style={{
                              height: "50px",
                              width: "380px",
                              border: "1px solid #ced4da",
                              fontSize: "15px",
                           }}
                           placeholder="Search company by name..."
                           type="text"
                           maxLength={100}
                           value={searchValue}
                           onChange={(e) => setSearchValue(e.target.value)}
                        />
                     </Form.Group>
                  </div>
                  <div className="scroll-container">
                     <div className="table-responsive border-bottom my-3">
                        <DataTable value={displayedCompanyList} tableStyle={{ minWidth: '50rem' }}  paginator rows={8} className={`${displayedCompanyList.length < 3 && displayedCompanyList.length > 0
                          ? "increasePaddingBottom"
                          : null
                        }`}>
                           <Column field="key" header="#"></Column>
                           <Column field="name" filterField="name" header="Name" ></Column>
                           <Column field="phone" filterField="name" header="Phone" ></Column>
                           <Column field="address" filterField="name" header="Address" ></Column>
                           <Column field="pincode" filterField="name" header="Pincode" ></Column>
                           <Column field="company_code" header="Company Code" body={(rowData) => {
                            if (!Number(rowData.company_code)) {
                              return "-";
                            } else {
                              return rowData.company_code;
                            }
                           }}></Column>
                           <Column field="type" header="Type" body={(rowData) => {
                            if (rowData.is_reseller_company == true) {
                              return "Reseller Company";
                            } else if (rowData.is_own_company == true) {
                              return "End User";
                            } else {
                              return "-";
                            }
                           }}></Column>
                           <Column field="credits_available" header="Voice Credits" ></Column>
                           <Column field="tts_credits" header="TTS Credits" ></Column>
                           <Column
                              field="strategies"
                              header="Call Strategies"
                              body={strategiesTemplate}
                            />
                            <Column
  field="groups"
  header="Company Groups"
  body={groupsTemplate}
/>

<Column
  field="locations"
  header="Company Locations"
  body={locationsTemplate}
/>
                           {/* <Column field="subUserLicenceId.total_licence.company" header="Total Licence" ></Column>
                           <Column field="subUserLicenceId.available_licence.company" header="Available Licence" ></Column> */}
                            <Column field="company_creator.username" header="Created by" ></Column>
                           <Column field="created_at" header="Created Date" body={(rowData) =>
                                    new Date(rowData.created_at).toLocaleString("en-IN", {
                                       day: "2-digit",
                                       month: "short",
                                       year: "numeric",
                                       hour: "2-digit",
                                       minute: "2-digit",
                                       second: "2-digit",
                                    })
                                 }></Column>
                                 <Column field="updated_at" header="Updated Date" body={(rowData) =>
                                    new Date(rowData.updated_at).toLocaleString("en-IN", {
                                       day: "2-digit",
                                       month: "short",
                                       year: "numeric",
                                       hour: "2-digit",
                                       minute: "2-digit",
                                       second: "2-digit",
                                    })
                                 }></Column>
                           <Column header={isOwnCompany ? "Current Licence" : "Actions"} body={(rowData) => {
                            if (isOwnCompany) { 
                              const lic = rowData.available_licence;
                              if (!lic) return "-";
                              return (
                                <div style={{ lineHeight: "1.6" }}>
                                  <span><b>Channels:</b> <span style={{ fontStyle: "italic" }}>{lic.channel}</span>, {" "}</span>
                                  <span><b>Live Agents:</b> <span style={{ fontStyle: "italic" }}>{lic.live_agent}</span>, {" "}</span>
                                  <span><b>Call Centers:</b> <span style={{ fontStyle: "italic" }}>{lic.role_ccadmin}</span>, {" "}</span>
                                  <span><b>Total Agents:</b> <span style={{ fontStyle: "italic" }}>{lic.role_ccagent}</span></span>
                                </div>
                              );
                            }
                            return RenderActionComponent(rowData.id, rowData.category, )
                            }} />
                        </DataTable>
                     </div>
                  </div>
                  </Card.Body>
               </Card>
            </Col>
         </Row>
      </div>
      <RenderAddCreditModal
              show={showAddCreditModel}
              setShow={setShowAddCreditModel}
              setConfirmUpdateCredit={setConfirmCredits}
              creditsValue={addCreditsValue}
              setCreditsValue={setAddCreditsValue}
              availableCredits={addCreditsId ? Number(companylist.find(c => c.id === addCreditsId)?.credits_available || 0) : 0}
            />
             <RenderRemoveCreditModal
              show={showRemoveCreditModel}
              setShow={setShowRemoveCreditModel}
              setConfirmReduceUpdateCredit={setConfirmReduceCredits}
              removeCreditsValue={removeCreditsValue}
              setRemoveCreditsValue={setRemoveCreditsValue}
              availableCredits={removeCreditsId ? Number(companylist.find(c => c.id === removeCreditsId)?.credits_available || 0) : 0}
            />

            <RenderAddCreditModal
                    show={showAddTtsCreditModel}
                    setShow={setShowAddTtsCreditModel}
                    setConfirmUpdateCredit={setConfirmTtsCredits}
                    creditsValue={addTtsCreditsValue}
                    setCreditsValue={setAddTtsCreditsValue}
                    title="Add TTS Credits"
                    availableCredits={addTtsCreditsId ? Number(companylist.find(c => c.id === addTtsCreditsId)?.tts_credits || 0) : 0}
                  />
                  <RenderRemoveCreditModal
                    show={showRemoveTtsCreditModel}
                    setShow={setShowRemoveTtsCreditModel}
                    setConfirmReduceUpdateCredit={setConfirmReduceTtsCredits}
                    removeCreditsValue={removeTtsCreditsValue}
                    setRemoveCreditsValue={setRemoveTtsCreditsValue}
                    title="Remove TTS Credits"
                    availableCredits={removeTtsCreditsId ? Number(companylist.find(c => c.id === removeTtsCreditsId)?.tts_credits || 0) : 0}
                  />
{/* 
            <ToastNotification
                    show_toast={showToast}
                    set_show_toast={setShowToast}
                    {...toastProps}
                  /> */}
                  <Modal 
                    show={showStrategiesModal} 
                    onHide={() => {
                      setShowStrategiesModal(false)
                      setUserCallStrategies(null);
                      setUserCallStrategiesUserName(null);
                    }} 
                    centered
                    dialogClassName="company-strategies-modal"
                  >
                    <style>
                      {`
                        .company-strategies-modal .modal-dialog {
                          max-width: 420px !important;
                        }
                        .company-strategies-modal .modal-content {
                          border-radius: 14px !important;
                          overflow: hidden;
                          box-shadow: 0 25px 60px rgba(0,0,0,0.25) !important;
                        }
                        .company-strategies-modal .modal-header {
                          background: linear-gradient(135deg, #1e2a55, #2f4b8f) !important;
                          color: white !important;
                          border-bottom: none !important;
                          border-radius: 14px 14px 0 0 !important;
                          padding: 18px 24px !important;
                        }
                        .company-strategies-modal .modal-title {
                          color: white !important;
                          font-size: 20px !important;
                          font-weight: 600 !important;
                          letter-spacing: 0.3px !important;
                          margin: 0 !important;
                        }
                        .company-strategies-modal .btn-close {
                          filter: brightness(0) invert(1) !important;
                          opacity: 0.8 !important;
                          font-size: 20px !important;
                          transition: opacity 0.2s !important;
                        }
                        .company-strategies-modal .btn-close:hover {
                          opacity: 1 !important;
                        }
                        .company-strategies-modal .modal-body {
                          padding: 24px !important;
                        }
                      `}
                    </style>
                    <Modal.Header>
                      <Modal.Title>Company Call Strategies</Modal.Title>
                      <button
                        type="button"
                        className="btn-close btn-close-white"
                        onClick={() => {
                          setShowStrategiesModal(false)
                          setUserCallStrategies(null);
                          setUserCallStrategiesUserName(null);
                        }}
                        aria-label="Close"
                      />
                    </Modal.Header>
                    <Modal.Body>
                      <div style={{ 
                        fontSize: "16px", 
                        fontWeight: "500", 
                        color: "#1f2937", 
                        marginBottom: "16px" 
                      }}>
                        Company Name: <span style={{ color: "#6b7280", fontWeight: "400" }}>{userCallStrategiesUserName}</span>
                      </div>
                      <div style={{ 
                        fontSize: "15px", 
                        fontWeight: "600", 
                        marginBottom: "12px", 
                        color: "#1f2937" 
                      }}>
                        Call Strategies
                      </div>
                      <div>
                        {userCallStratgies ? (
                          userCallStratgies.split(", ").map((strategy, index) => (
                            <div key={index} style={{ 
                              display: "flex", 
                              alignItems: "center", 
                              marginBottom: "12px",
                              fontSize: "14px",
                              color: "#374151"
                            }}>
                              <div style={{
                                width: "20px",
                                height: "20px",
                                background: "#22c55e",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "white",
                                fontSize: "12px",
                                marginRight: "10px",
                                flexShrink: 0
                              }}>
                                ✓
                              </div>
                              <span>{strategy.trim()}</span>
                            </div>
                          ))
                        ) : (
                          <div style={{ color: "#6b7280", fontSize: "14px" }}>No strategies assigned</div>
                        )}
                      </div>
                    </Modal.Body>
                    <div style={{
                      backgroundColor: "white",
                      borderTop: "1px solid #e5e7eb",
                      padding: "16px 24px",
                      marginTop: "0",
                      borderRadius: "0 0 14px 14px",
                      display: "flex",
                      justifyContent: "flex-end"
                    }}>
                      <BootstrapButton
                        onClick={() => {
                          setShowStrategiesModal(false)
                          setUserCallStrategiesUserName(null);
                          setUserCallStrategies(null);
                        }}
                        style={{
                          padding: "8px 22px",
                          border: "none",
                          borderRadius: "8px",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "white",
                          background: "linear-gradient(135deg, #4f6edb, #3b5ccc)",
                          boxShadow: "0 8px 18px rgba(79,110,219,0.35)",
                          transition: "all 0.2s",
                          cursor: "pointer"
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.transform = "translateY(-2px)";
                          e.target.style.boxShadow = "0 12px 22px rgba(79,110,219,0.45)";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = "translateY(0)";
                          e.target.style.boxShadow = "0 8px 18px rgba(79,110,219,0.35)";
                        }}
                      >
                        Close
                      </BootstrapButton>
                    </div>
                  </Modal>
<Modal
  show={showGroupsModal}
  onHide={() => {
    setShowGroupsModal(false);
    setSelectedGroups([]);
    setSelectedCompanyName(null);
  }}
  centered
  dialogClassName="company-groups-modal"
>
  <style>
    {`
      .company-groups-modal .modal-header {
        background: linear-gradient(135deg, #1e2a55, #2f4b8f) !important;
        color: white !important;
        border-bottom: none !important;
        border-radius: 14px 14px 0 0 !important;
        padding: 18px 24px !important;
      }
      .company-groups-modal .modal-title {
        color: white !important;
        font-size: 20px !important;
        font-weight: 600 !important;
        letter-spacing: 0.3px !important;
        margin: 0 !important;
      }
      .company-groups-modal .btn-close {
        filter: brightness(0) invert(1) !important;
        opacity: 0.8 !important;
        font-size: 20px !important;
        transition: opacity 0.2s !important;
      }
      .company-groups-modal .btn-close:hover {
        opacity: 1 !important;
      }
      .company-groups-modal .modal-content {
        border-radius: 14px !important;
        overflow: hidden;
        box-shadow: 0 25px 60px rgba(0,0,0,0.25) !important;
      }
      .company-groups-modal .modal-body {
        padding: 24px !important;
      }
      .company-groups-modal .modal-footer {
        border-top: 1px solid #e5e7eb;
        padding: 16px 24px;
        display: flex;
        justify-content: flex-end;
        gap: 10px;
      }
    `}
  </style>
  <Modal.Header>
    <Modal.Title>Company Groups</Modal.Title>
    <button
      type="button"
      className="btn-close btn-close-white"
      onClick={() => {
        setShowGroupsModal(false);
        setSelectedGroups([]);
        setSelectedCompanyName(null);
      }}
      aria-label="Close"
    />
  </Modal.Header>
  <Modal.Body>
    <h6 className="mb-3">Company Name: {selectedCompanyName}</h6>
    {selectedGroups.length > 0
      ? selectedGroups.join(", ")
      : "No Groups Assigned"}
  </Modal.Body>
  <Modal.Footer>
    <Button
      onClick={() => {
        setShowGroupsModal(false);
        setSelectedGroups([]);
        setSelectedCompanyName(null);
      }}
      style={{
        padding: "8px 22px",
        border: "none",
        borderRadius: "8px",
        fontSize: "14px",
        fontWeight: "500",
        color: "white",
        background: "linear-gradient(135deg, #4f6edb, #3b5ccc)",
        boxShadow: "0 8px 18px rgba(79,110,219,0.35)",
        transition: "all 0.2s",
        cursor: "pointer"
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = "translateY(-2px)";
        e.target.style.boxShadow = "0 12px 22px rgba(79,110,219,0.45)";
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = "translateY(0)";
        e.target.style.boxShadow = "0 8px 18px rgba(79,110,219,0.35)";
      }}
    >
      Close
    </Button>
  </Modal.Footer>
</Modal>
<Modal
  show={showLocationsModal}
  onHide={() => {
    setShowLocationsModal(false);
    setSelectedLocations([]);
    setSelectedCompanyName(null);
  }}
  centered
  dialogClassName="company-locations-modal"
>
  <style>
    {`
      .company-locations-modal .modal-header {
        background: linear-gradient(135deg, #1e2a55, #2f4b8f) !important;
        color: white !important;
        border-bottom: none !important;
        border-radius: 14px 14px 0 0 !important;
        padding: 18px 24px !important;
      }
      .company-locations-modal .modal-title {
        color: white !important;
        font-size: 20px !important;
        font-weight: 600 !important;
        letter-spacing: 0.3px !important;
        margin: 0 !important;
      }
      .company-locations-modal .btn-close {
        filter: brightness(0) invert(1) !important;
        opacity: 0.8 !important;
        font-size: 20px !important;
        transition: opacity 0.2s !important;
      }
      .company-locations-modal .btn-close:hover {
        opacity: 1 !important;
      }
      .company-locations-modal .modal-content {
        border-radius: 14px !important;
        overflow: hidden;
        box-shadow: 0 25px 60px rgba(0,0,0,0.25) !important;
      }
      .company-locations-modal .modal-body {
        padding: 24px !important;
      }
      .company-locations-modal .modal-footer {
        border-top: 1px solid #e5e7eb;
        padding: 16px 24px;
        display: flex;
        justify-content: flex-end;
        gap: 10px;
      }
    `}
  </style>
  <Modal.Header>
    <Modal.Title>Company Locations</Modal.Title>
    <button
      type="button"
      className="btn-close btn-close-white"
      onClick={() => {
        setShowLocationsModal(false);
        setSelectedLocations([]);
        setSelectedCompanyName(null);
      }}
      aria-label="Close"
    />
  </Modal.Header>
  <Modal.Body>
    <h6 className="mb-3">Company Name: {selectedCompanyName}</h6>
    {selectedLocations.length > 0
      ? selectedLocations.join(", ")
      : "No Locations Assigned"}
  </Modal.Body>
  <Modal.Footer>
    <Button
      onClick={() => {
        setShowLocationsModal(false);
        setSelectedLocations([]);
        setSelectedCompanyName(null);
      }}
      style={{
        padding: "8px 22px",
        border: "none",
        borderRadius: "8px",
        fontSize: "14px",
        fontWeight: "500",
        color: "white",
        background: "linear-gradient(135deg, #4f6edb, #3b5ccc)",
        boxShadow: "0 8px 18px rgba(79,110,219,0.35)",
        transition: "all 0.2s",
        cursor: "pointer"
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = "translateY(-2px)";
        e.target.style.boxShadow = "0 12px 22px rgba(79,110,219,0.45)";
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = "translateY(0)";
        e.target.style.boxShadow = "0 8px 18px rgba(79,110,219,0.35)";
      }}
    >
      Close
    </Button>
  </Modal.Footer>
</Modal>
<Modal show={showDeleteModal} onHide={closeDeleteModal} centered>
   <Modal.Header closeButton>
      <Modal.Title>Delete Company</Modal.Title>
   </Modal.Header>

   <Modal.Body>
      Are you sure you want to delete this company? Licence Values cannot be returned.
   </Modal.Body>

   <Modal.Footer>
      <Button
         label="Cancel"
         className="p-button-text"
         onClick={closeDeleteModal}
      />

      <Button
         label="Delete"
         className="p-button-danger"
         onClick={confirmDelete}
         disabled={buttonDisable}
      />
   </Modal.Footer>
</Modal>
     </>
  )

}

export default CompanyList;